import { LOC_INCREMENTING_VALUE, LOC_VALUE } from "../../locKeys";
import { string2number } from "../../utils";
import { Action } from "./Action";

export class IncrementDateTime extends Action {
    public attrName: string;
    public precision: DateTimePrecision;
    public value: number;

    constructor(attrName: string, precision: string, value: string, condition: string, comment: string) {
        super(condition, comment);

        this.attrName = attrName;
        this.precision = (DateTimePrecision as any)[precision];
        this.value = string2number(value, 1);
    }

    public override async validate(): Promise<void> {
        if (!this.attrName)
            throw new Error(await this.getActionErrorMessage(LOC_VALUE, LOC_INCREMENTING_VALUE));
    }
}

export enum DateTimePrecision {
    second = "second",
    minute = "minute",
    hour = "hour",
    day = "day",
    week = "week",
    month = "month",
    year = "year",
    number = "number",
}
